import { comments, comments_with_replies, users_comments, users_comments_model } from "@core/gql-mockups/comments";
import { pagination } from "@core/gql-mockups/pagination";

const { minimize_str } = require("@core/helpers/string");

export const GET_COMMENTS = minimize_str(`
query ($model_id: ID, $page: Int, $limit: Int, $filter: CommentFilter, $sort: CommentSort) {
  result: getComments(model_id: $model_id,page: $page, limit: $limit, filter: $filter, sort: $sort) {
    paginate ${pagination}
    data ${comments}
  }
}
`);

export const GET_COMMENTS_WITH_REPLIES = minimize_str(`
query ($model_id: ID, $page: Int, $limit: Int, $filter: CommentFilter, $sort: CommentSort) {
  result: getComments(model_id: $model_id,page: $page, limit: $limit, filter: $filter, sort: $sort) {
    paginate ${pagination}
    data ${comments_with_replies}
  }
}
`);


// same queries as above with a site's own selection set (`mockup`), e.g. to read extra Comment fields
export const GET_COMMENTS_BY_MOCKUP = (mockup) => minimize_str(`
query ($model_id: ID, $page: Int, $limit: Int, $filter: CommentFilter, $sort: CommentSort) {
  result: getComments(model_id: $model_id,page: $page, limit: $limit, filter: $filter, sort: $sort) {
    paginate ${pagination}
    data ${mockup}
  }
}
`);

export const GET_USER_COMMENTS_MODEL = minimize_str(`
  query ($page: Int, $limit: Int, $filter: CommentFilter, $sort: CommentSort) {
    result: getUserComments(page: $page, limit: $limit, filter: $filter, sort: $sort) {
      paginate ${pagination}
      data ${users_comments_model}
    }
  }
`);

export const GET_USER_COMMENTS = (custom_gql) => minimize_str(`
  query ($page: Int, $limit: Int, $filter: CommentFilter, $sort: CommentSort) {
    result: getUserComments(page: $page, limit: $limit, filter: $filter, sort: $sort) {
      data ${custom_gql || users_comments}
      paginate ${pagination}
    }
  }
`);